// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36hvf","col":"styles_col__369BE","actions":"styles_actions__1bGLj","conflict":"styles_conflict__2YTHQ"};